import { useAppTheme } from "@hooks/useAppTheme";
import SetExamDateContainer from "components/SetExamDateContainer";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pressable, View } from "react-native";
import { Text, TextInput } from "react-native-paper";
const OnboardingTestDate = ({
	testDate,
	onDateChange,
}: {
	testDate: string;
	onDateChange: (date: Date) => void;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const [showDatePicker, setShowDatePicker] = useState(false);

	const openDatePicker = () => {
		setShowDatePicker(true);
	};

	const closeDatePicker = () => {
		setShowDatePicker(false);
	};

	return (
		<View>
			<Pressable onPress={openDatePicker} style={{ cursor: "pointer" }}>
				<TextInput
					placeholder="Date"
					mode="outlined"
					pointerEvents="none"
					editable={false}
					value={testDate}
					right={<TextInput.Icon icon="calendar" onPress={openDatePicker} />}
				/>
			</Pressable>

			<Text
				variant="bodyLarge"
				style={{
					color: theme.palette.text.secondary,
					textAlign: "center",
					marginTop: 16,
				}}
			>
				{t("onboarding.steps.testDate.bottomLabel")}
			</Text>

			<SetExamDateContainer
				showDatePicker={showDatePicker}
				toggleShowDatePicker={closeDatePicker}
				handleDateChange={onDateChange}
			/>
		</View>
	);
};

export default OnboardingTestDate;
